import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./spa/App";
import PlayerApp from "./player/PlayerApp";
import "./Fullstory.ts";
import { brand, isReallyChitty } from "./shared/util/branding";

// Set page title and favicon based on brand
document.title = brand.name;
if (isReallyChitty()) {
  const favicon = document.querySelector('link[rel="icon"]') as HTMLLinkElement;
  if (favicon) {
    favicon.href = "/reallychitty-favicon.svg";
  }
}

const isPlayerRoute = document.location.pathname.startsWith("/player");
const isSpaRoute = document.location.pathname.startsWith("/spa");

if (!isPlayerRoute && !isSpaRoute) {
  document.location.pathname = "/spa";
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    {isPlayerRoute ? <PlayerApp /> : <App />}
  </StrictMode>
);
